export function createHistory(): HistoryLog {
  return [];
}
